import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

// Handles the OAuth return: exchanges session_id (URL fragment) for a session, then redirects.
const AuthCallback = () => {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) { navigate('/community', { replace: true }); return; }
      try {
        const res = await fetch(`${API}/api/auth/session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!res.ok) throw new Error('Session exchange failed');
        // clear the fragment then refresh auth state
        const dest = window.location.pathname.startsWith('/community') ? window.location.pathname : '/community';
        window.history.replaceState(null, '', dest);
        await checkAuth();
        navigate(dest, { replace: true });
      } catch (e) {
        setError('We could not sign you in. Please try again.');
      }
    };
    run();
  }, [navigate, checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        {!error ? (
          <>
            <div className="w-10 h-10 border-2 border-slate-300 border-t-slate-900 rounded-full animate-spin mx-auto mb-4" />
            <p className="text-slate-500 text-sm">Signing you in…</p>
          </>
        ) : (
          <>
            <p className="text-red-600 text-sm mb-4">{error}</p>
            <button onClick={() => navigate('/community')} className="px-5 py-2.5 rounded-full bg-slate-900 text-white text-sm font-semibold">Back to Community</button>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthCallback;
